// Ajax add-to-cart + cart count
document.addEventListener('submit', async function (e) {
  const f = e.target.closest('.atc-form');
  if (!f) return;
  e.preventDefault();
  const btn = f.querySelector('.atc');
  const label = btn.textContent;
  btn.textContent = 'Adding…';
  try {
    await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: f.querySelector('[name=id]').value, quantity: 1 }) });
    const cart = await (await fetch('/cart.js')).json();
    const bag = document.getElementById('bag');
    if (bag) bag.textContent = cart.item_count;
    btn.textContent = 'Added ✓';
    btn.classList.add('added');
  } catch (err) { btn.textContent = 'Try again'; }
  setTimeout(() => { btn.textContent = label; btn.classList.remove('added'); }, 1500);
});
